import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { createQueryClient } from './util/query-client';
import './index.css';
import { applyStoredColorSchemeBodyClass } from './util/color-scheme-preference';
import HubApp from './hub-app';
import reportWebVitals from './reportWebVitals';

applyStoredColorSchemeBodyClass();

const queryClient = createQueryClient();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <HubApp />
        </QueryClientProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
